import axios from "src/lib/axios";

export const login = async (data) => {
  const { data: response } = await axios.post(`/v2/login`, data);
  return response.data;
};

export const getUserInfo = async () => {
  const { data: response } = await axios.get(`/v2/me`);
  return response.data;
};

export const newPassWord = async (data) => {
  const { data: response } = await axios.post(`/v2/new-password`, data);
  return response.data;
};

export const recoverPassword = async (email) => {
  const { data: response } = await axios.post(`/v2/recover-password`, email);
  return response.data;
};
